import { GrowFlex as r } from "../../Flex/Flex.js";
import { p as o } from "../../../styled-components.browser.esm-DBaC0ZEI.mjs";
const t = o(r)`
  padding: var(--space-16);
  background-color: var(--gray-1);
  border-top-left-radius: var(--br-1);
  border-top-right-radius: var(--br-1);
  border-bottom: 1px solid var(--gray-4);
`;
export {
  t as BulkActionWrapper
};
//# sourceMappingURL=style.js.map
